import { render } from "./ServerError.vue?vue&type=template&id=25cbf594&scoped=true&ts=true&lang=pug"
import script from "./ServerError.vue?vue&type=script&lang=ts"
export * from "./ServerError.vue?vue&type=script&lang=ts"

import "./ServerError.vue?vue&type=style&index=0&id=25cbf594&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25cbf594"]])

export default __exports__